var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmrtExplorerBlueActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2363F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    d: "M11 1 V6 C11 3 10 1.5 8 1.5 C6 1.5 5 3 5 6 V10 C5 13 6 14.5 8 14.5 C10 14.5 11 13 11 10 V15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmrtExplorerBlueActive);
export default __webpack_public_path__ + "static/media/smrtExplorer_blue_active.7d354a817f39d2e25462ed5d0a84d3ed.svg";
export { ForwardRef as ReactComponent };